import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { ModalProps, ModalPublicMethods } from '~/core/dto/components/modalDTO';

import './Modal.styles.css';
import Spacer from '../Spacer';

const Modal = forwardRef<ModalPublicMethods, ModalProps>( ( { subtitle, title, onHide }, ref ) => {

  const [ opened, setOpened ] = useState( false );

  const hide = ( answer: boolean ) => {

    setOpened( false );
    onHide?.( answer );

  };

  useImperativeHandle( ref, () => ( {
    open: () => setOpened( true ),
  } ) );

  if ( !opened ) {

    return null;

  }

  return (
    <div className="modalContainer flexColumn alignCenter justifyCenter">
      <div className="modalContent">
        <p className="subtitle textCenter">{subtitle}</p>
        <Spacer size={8} />
        <h2 className="textCenter">{title}</h2>
        <Spacer size={16} />
        <div className="buttons flexRow justifySpaceBetween">
          <div className="button cursorPointer" onClick={() => hide( false )} aria-hidden>
            <p>No</p>
          </div>
          <div className="button cursorPointer" onClick={() => hide( true )} aria-hidden>
            <p>Yes</p>
          </div>
        </div>
      </div>
    </div>
  );

} );

export default Modal;
